import sendRequest from '../client/sendRequest';

const BASE_URL = '/api/blogPosts';

/* ---------- Create ---------- */

// Create a comment for a specific blog post
export async function createComment(blogPostId, data) {
  return await sendRequest(`${BASE_URL}/${blogPostId}/comments`, 'POST', data);
}

/* ---------- Update ---------- */

// Update a comment for a specific blog post
export async function updateComment(blogPostId, commentId, data) {
  return await sendRequest(
    `${BASE_URL}/${blogPostId}/comments/${commentId}`,
    'PUT',
    data,
  );
}

/* ---------- Delete ---------- */

// Delete a comment
export async function deleteComment(blogPostId, commentId) {
  return await sendRequest(
    `${BASE_URL}/${blogPostId}/comments/${commentId}`,
    'DELETE',
  );
}
